import { motion } from "framer-motion";

const PHOTO_URL =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_rrhh-platform-1/artifacts/f3eac9fe44fafab0_Retrato%20profesional%20con%20blazer%20y%20camisa%20oscura.png";

/**
 * Founder portrait — photo of Francesc Riera treated deliberately inside a
 * dark-green editorial frame with corner marks, gradient orb and grid overlay.
 */
export default function FounderAvatar() {
  return (
    <div className="relative aspect-[4/5] w-full max-w-[520px] bg-[#06231D] overflow-hidden rounded-2xl">
      {/* grid */}
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.07]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(247,249,248,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(247,249,248,0.6) 1px, transparent 1px)",
          backgroundSize: "48px 48px",
        }}
      />

      {/* soft brand orb behind the subject */}
      <motion.div
        initial={{ scale: 0.9 }}
        animate={{ scale: [0.9, 1.05, 0.9] }}
        transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
        aria-hidden
        className="absolute -top-24 -right-16 w-[420px] h-[420px] rounded-full blur-[80px] opacity-60 brand-gradient"
      />

      {/* portrait */}
      <img
        src={PHOTO_URL}
        alt="Francesc Riera"
        loading="lazy"
        draggable={false}
        className="absolute inset-0 w-full h-full object-cover object-top select-none"
      />

      {/* bottom fade so labels stay readable */}
      <div
        aria-hidden
        className="absolute inset-x-0 bottom-0 h-40 pointer-events-none"
        style={{
          background:
            "linear-gradient(to top, rgba(6,35,29,0.75), rgba(6,35,29,0))",
        }}
      />

      {/* corner marks */}
      <div className="absolute inset-6 pointer-events-none">
        <div className="absolute top-0 left-0 w-4 h-px bg-[#C9A84C]" />
        <div className="absolute top-0 left-0 w-px h-4 bg-[#C9A84C]" />
        <div className="absolute top-0 right-0 w-4 h-px bg-[#C9A84C]" />
        <div className="absolute top-0 right-0 w-px h-4 bg-[#C9A84C]" />
        <div className="absolute bottom-0 left-0 w-4 h-px bg-[#C9A84C]" />
        <div className="absolute bottom-0 left-0 w-px h-4 bg-[#C9A84C]" />
        <div className="absolute bottom-0 right-0 w-4 h-px bg-[#C9A84C]" />
        <div className="absolute bottom-0 right-0 w-px h-4 bg-[#C9A84C]" />
      </div>
    </div>
  );
}
